'use client';

import { c as _c } from "react/compiler-runtime";
import { RevealText } from '@/app/onboarding/_components/workspace-setup/reveal-text';
import { SLIDE_DURATION_MS, SLIDE_TRANSITION_MS } from './constants/slide-timing';
import { RotatingWord } from './rotating-word';
import type { AuthPanelSlide } from './types/auth-panel-deck';

/**
 * Eyebrow and headline. The headline's opening writes
 * itself in word by word; its last line rolls through the
 * slide's words, spaced so the last one lands before the
 * slide moves on.
 */
// primary-700: text-primary is too light on the mint
// card, and no semantic token is a darker brand green.
export function SlideHeading(t0) {
  const $ = _c(22);
  const {
    slide
  } = t0;
  const wordIntervalMs = (SLIDE_DURATION_MS - SLIDE_TRANSITION_MS) / slide.rotatingWords.length;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <span className="bg-primary size-1.5 animate-pulse rounded-full" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== slide.eyebrow) {
    t2 = <p className="text-primary-700 mb-2 flex items-center gap-2 text-xs font-medium md:text-sm">{t1}{slide.eyebrow}</p>;
    $[1] = slide.eyebrow;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const t3 = slide.title;
  let t4;
  if ($[3] !== slide.rotatingWords) {
    t4 = slide.rotatingWords.join(", ");
    $[3] = slide.rotatingWords;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== slide.title || $[6] !== t4) {
    t5 = <span className="sr-only">{t3} {t4}</span>;
    $[5] = slide.title;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== slide.title) {
    t6 = <RevealText text={slide.title} className="block" delay={0.05} data-sentry-element="RevealText" data-sentry-source-file="slide-heading.tsx" />;
    $[8] = slide.title;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== slide.rotatingWords || $[11] !== wordIntervalMs) {
    t7 = <RotatingWord words={slide.rotatingWords} delay={0.2} intervalMs={wordIntervalMs} className="font-ivar text-primary-700 font-normal" data-sentry-element="RotatingWord" data-sentry-source-file="slide-heading.tsx" />;
    $[10] = slide.rotatingWords;
    $[11] = wordIntervalMs;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t6 || $[14] !== t7) {
    t8 = <span aria-hidden={true} className="block">{t6}{t7}</span>;
    $[13] = t6;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t5 || $[17] !== t8) {
    t9 = <h2 className="text-foreground max-w-md text-xl leading-[1.2] font-medium md:text-[28px] xl:text-[32px]">{t5}{t8}</h2>;
    $[16] = t5;
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== t2 || $[20] !== t9) {
    t10 = <div className="flex flex-col items-center text-center" data-sentry-component="SlideHeading" data-sentry-source-file="slide-heading.tsx">{t2}{t9}</div>;
    $[19] = t2;
    $[20] = t9;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  return t10;
}